var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Button',{staticClass:"u-b1",attrs:{"data-test":"unlock-offer-button","icon":"unlock","type":"default"},on:{"click":_vm.unlockOffer}},[_vm._v(" "+_vm._s(_vm.$t('Unlock offer'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }